import {
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { Product, ProductWarehouseInfo } from "../../services/swagger";
import { useTranslation } from "react-i18next";
import FieldLabel from "../atoms/FieldLabel";
import { useMemo } from "react";

interface WarehouseInfoProps {
  product: Product;
}

export default function WarehouseInfo(props: WarehouseInfoProps) {
  const { t } = useTranslation("Product");
  const { product } = props;
  const warehouseInfoList: ProductWarehouseInfo[] = useMemo(() => {
    const arr: ProductWarehouseInfo[] = [];
    const sapWarehouseInfoList = product.sapWarehouseInfo;
    const normalWarehouseInfoList = product.warehouseInfo;
    for (const warehouseInfo of [
      ...normalWarehouseInfoList,
      ...sapWarehouseInfoList,
    ]) {
      if (arr.some((w) => w.warehouse.code === warehouseInfo.warehouse.code))
        continue;
      arr.push(warehouseInfo);
    }
    return arr;
  }, []);

  return (
    <Stack spacing={1}>
      <FieldLabel>{t("WarehouseInfo")}</FieldLabel>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>{t("Name")}</TableCell>
              <TableCell>{t("QuantityInStock")}</TableCell>
              <TableCell>{t("AmountUsed")}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {warehouseInfoList.map((warehouseInfo) => (
              <TableRow key={warehouseInfo.warehouse.code} hover>
                <TableCell>
                  {warehouseInfo.warehouse.code} |{" "}
                  {warehouseInfo.warehouse.name}
                </TableCell>
                <TableCell>{warehouseInfo.quantityInStock}</TableCell>
                <TableCell>{warehouseInfo.amountUsed}</TableCell>
              </TableRow>
            ))}
            <TableRow hover>
              <TableCell sx={{ fontWeight: "bold" }}>{t("Total")}</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>
                {product?.totalQuantityInStock}
              </TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>
                {product?.totalAmountUsed}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Stack>
  );
}
